import React, { useEffect, useState } from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import OtpComponent from "../OtpComponent";

const VendorSignUp = () => {
  const [data, setData] = useState({
    email: "",
    password: "",
    confirmPassword: ""
  });
  const [otp, setOtp] = useState("");
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const [timer, setTimer] = useState(0);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate();

  useEffect(() => {
    let countdown;
    if (isOtpModalOpen) {
      setTimer(60);
      countdown = setInterval(() => {
        setTimer((prev) => {
          if (prev === 1) {
            clearInterval(countdown);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(countdown);
  }, [isOtpModalOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleRegister = async () => {
    setLoading(true)
    try {
      const verify = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/auth/verify-signup-otp?email=${data.email}&otp=${otp}`
      );
      if (verify) {
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/vendor`, {
          email: data.email,
          password: data.password
        });
        setIsOtpModalOpen(false);

        const res = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/auth/signin`,
          { username: data.email, password: data.password }
        );
        localStorage.removeItem("userCredentials");
        localStorage.setItem('user', JSON.stringify(res.data));
        navigate("/vendor/details");
      }
    } catch (error) {
      localStorage.removeItem("userCredentials");
      setData({
        email: "",
        password: "",
        confirmPassword: ""
      });
      setIsOtpModalOpen(false);
      setError(error.response?.data?.Exception || "Something went wrong")
    } finally {
      setLoading(false)
    }
  };

  const handleSendOtp = async () => {
    localStorage.setItem("userCredentials", JSON.stringify(data));
    try {
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/auth/generate-signup-otp?email=${data.email}`
      );
      setIsOtpModalOpen(true);
    } catch (error) {
      setOtp("");
      console.log("Please enter valid details");
    }
  };

//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem("userCredentials"))) {
//       setIsOtpModalOpen(true);
//       setData(JSON.parse(localStorage.getItem("userCredentials")));
//     }
//   }, []);

  return (
    <div className="App" style={{position: 'relative'}}>
      {loading && <div className="loading-div"></div>}
        <div className="border-container">
            <form style={{width: '30%'}}>
                <Typography variant="h4" textAlign={"center"} mb={5}>
                Vendor Sign Up
                </Typography>
                <label htmlFor="email">Email ID</label>
                <input
                type="email"
                name="email"
                id="email"
                onChange={handleChange}
                />
                <label htmlFor="password">Password</label>
                <input
                type="password"
                name="password"
                id="password"
                onChange={handleChange}
                />
                <label htmlFor="confirmPassword">Confirm Password</label>
                <input
                type="password"
                name="confirmPassword"
                id="confirmPassword"
                onChange={handleChange}
                />
                {error && <p className="error">{error}</p>}
                <Button className="btn-contained" fullWidth onClick={handleSendOtp}>
                Send OTP
                </Button>
                <div style={{ display: "flex", justifyContent: "center" }}>
                <a href="/" style={{ fontSize: '13px' }}>
                    Sign In
                </a>
                </div>
            </form>

        </div>

      {/* OTP Modal */}
      <Modal open={isOtpModalOpen} onClose={() => setIsOtpModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
            textAlign: "center",
          }}
        >
          <Typography variant="h6" mb={2}>
            Enter OTP
          </Typography>
          <Typography>OTP sent to {data && data.email}</Typography>
          <OtpComponent otp={otp} onOtpChange={setOtp} />
          <Typography fontSize="14px" mt={1}>
            Kindly check your email (including spam folder) for OTP.
          </Typography>

          <Typography fontSize="14px" color="red" mt={2}>
            OTP expires in {timer} seconds
          </Typography>

          <Button
          className="btn-contained"
            fullWidth
            sx={{ mt: 3 }}
            onClick={handleRegister}
          >
            Submit
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default VendorSignUp;
